import { getToken, hasChild, localSave, localRead } from '@/libs/util'
import Main from '@/components/main'
import { forEach } from '@/libs/tools'
import store from '@/store'

// 初始化路由
export const initRouter = (menuData) => {
  if (!getToken()) {
    return
  }
  localSave('userMenus', JSON.stringify(menuData))
  // 格式化菜单
  let list = formatMenu(menuData)
  // 刷新界面菜单
  store.commit('updateMenuList', list)
  return list
}

// 加载菜单，在创建路由时使用
export const loadMenu = (list = []) => {
  let data = localRead('userMenus')
  if (!data && list.length === 0) {
    return list
  }
  if (data) {
    list = formatMenu(JSON.parse(data))
  } else {
    list = formatMenu(list)
  }
  return list
}

// 格式化菜单
export const formatMenu = (list) => {
  let res = []
  forEach(list, item => {
    let obj = {
      path: item.path,
      name: item.name
    }
    obj.meta = item.meta
    // 惰性递归 ****
    if (item.parent === null) {
      obj.component = Main
    } else {
      // 惰性递归 ****
      let data = item.component
      // 这里需要改成自己定义的 .vue 夜间路径
      // obj.component = () => import('@/view' + data)
      obj.component = resolve => require(['@/view' + data], resolve)
    }
    if (hasChild(item)) {
      obj.children = formatMenu(item.children)
    }
    res.push(obj)
  })
  return res
}
